export const FONT_CLASS = {
  display: "font-display",
  "bn-elegant": "font-bn-display",
  "bn-clean": "font-bn",
  mono: "font-mono",
};

export const fontClass = (v, fallback = "font-display") => FONT_CLASS[v] || fallback;

export const FONT_OPTIONS = [
  { value: "display", label: "Modern Sans" },
  { value: "bn-elegant", label: "Bengali Elegant (Tiro Bangla)" },
  { value: "bn-clean", label: "Bengali Clean (Hind Siliguri)" },
  { value: "mono", label: "Typewriter Mono" },
];
